export { HttpError, HttpHeader } from './http.interface'
export { XmlRequest as Http } from './xml-request.adapter'
